import {
  FIELD_ERROR_TEXT_CLASS,
  FIELD_LABEL_CLASS,
  getErrorMessage,
  getFieldClass,
} from "./inputStyles";

const SelectInput = ({
  children,
  className,
  error,
  label,
  name,
  value,
  onChange,
  required = false,
  disabled = false,
  register,
}) => {
  const errorMessage = getErrorMessage(error);
  const registerProps = register && name ? register(name, { required }) : {};

  const handleChange = (event) => {
    registerProps.onChange?.(event);
    onChange?.(event);
  };

  return (
    <div className={`w-full ${className || ""}`}>
      {label ? (
        <label className={FIELD_LABEL_CLASS} htmlFor={name}>
          {label}
        </label>
      ) : null}
      <select
        id={name}
        className={getFieldClass(Boolean(error))}
        {...registerProps}
        onChange={handleChange}
        value={value}
        disabled={disabled}
      >
        {children}
      </select>
      {errorMessage ? (
        <small className={FIELD_ERROR_TEXT_CLASS}>{errorMessage}</small>
      ) : null}
    </div>
  );
};

export default SelectInput;
